module.exports = __webpack_public_path__ + "assets/bike_light.6ad48e5c.svg";